import React from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';

export const COLLECTION_CLIENTS_TABLE_TOOLTIP_ID = 'collection-clients-table-tooltip';

export const collectionClientsTooltipProps = (content: string) => ({
  'data-tooltip-id': COLLECTION_CLIENTS_TABLE_TOOLTIP_ID,
  'data-tooltip-content': content,
});

export const NOT_EMAILABLE_TOGGLE_TOOLTIP =
  'Cannot enable scheduled emails while the account is not emailable (credit-only | no past-due debits).';

export const RESIDENTIAL_SUPPRESSED_TOGGLE_TOOLTIP =
  'Residential clients are excluded from emailing in Configuration.';

export const NO_USABLE_EMAIL_TOGGLE_TOOLTIP =
  'No company email on file. Open the client to add a backup email.';

export const CollectionClientsTableTooltip: React.FC = () => (
  <ReactTooltip id={COLLECTION_CLIENTS_TABLE_TOOLTIP_ID} style={{ zIndex: 1500, maxWidth: 320 }} />
);
